module.exports = __webpack_public_path__ + "static/img/33.44a41926.png";